import Api from "./api"

const logIn = (params) => {
    return Api().post('/auth/login', params)
        .then(response => {
            return response
        })
}

const logOut = () => {
    return Api().post('/logout')
        .then(response => {
            return response
        })
}

export {logIn, logOut}